/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export abstract class DtoManager<T> {
  data: T;

  constructor(dto: T) {
    this.data = dto;
    this.checkIntegrity();
  }

  /**
   * controlla l'integrità del dto.
   * se viene riscontrata un'irregolarità dovrebbe generare un errore
   */
  abstract checkIntegrity(): void;
}
